import { useData } from '../../../hooks/useData';
import { Company } from '../../../types/appModels';
import { DataStatus } from '../../../types/appTypes';
import SelectInput from '../../Common/SelectInput/SelectInput';

export enum CompanySelectValueType {
  Id,
  Name,
}

type CompanySelectProps = {
  label?: string;
  placeholder?: string;
  isPlaceHolderSelectable?: boolean;
  name?: string;
  multiple: boolean;
  value?: string | string[];
  valid?: boolean;
  secondaryClass?: string;
  loadWhen?: boolean;
  valueType?: CompanySelectValueType;
  onChange: React.ChangeEventHandler<HTMLSelectElement> | undefined;
};

const CompanySelect = ({
  label,
  placeholder,
  isPlaceHolderSelectable,
  name,
  multiple,
  value,
  valid,
  secondaryClass,
  loadWhen,
  valueType,
  onChange,
}: CompanySelectProps) => {
  const { dataState: companyDataState } = useData<Company[]>({
    endpoint: `${process.env.REACT_APP_API_COMPANIES}?top=false`,
    initialData: [],
    initialStatus: DataStatus.Loading,
    loadWhen,
  });

  const companyOptions = companyDataState.data!.map((company) => {
    return {
      key: company.companyId,
      label: company.name,
      value:
        (valueType ?? CompanySelectValueType.Id) == CompanySelectValueType.Id
          ? company.companyId
          : company.name,
    };
  });

  const activePlaceholder =
    companyDataState.status === DataStatus.Loading ? 'Loading...' : placeholder;

  return (
    <SelectInput
      placeholder={activePlaceholder}
      isPlaceholderSelectable={isPlaceHolderSelectable}
      label={label}
      name={name}
      secondaryClass={secondaryClass}
      options={companyOptions}
      multiple={multiple}
      value={value}
      valid={valid}
      onChange={onChange}
    />
  );
};

export default CompanySelect;
